import styled from 'styled-components';
import Header from './Header';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Chat from './Chat';
import MainContent from './MainContent';

const GridContainer = styled.div`
  display: grid;
  grid-template-rows: 40px 75px 1fr;
  grid-template-columns: 80px repeat(4, 1fr) 10px;
  height: 100vh;
  background: var(--main-bg);

  @media (max-width: 1024px) {
    grid-template-columns: 60px repeat(4, 1fr) 5px;
  }

  @media (max-width: 768px) {
    grid-template-rows: 40px 60px 1fr;
    grid-template-columns: 1fr;
    height: auto;
  }

  @media (max-width: 480px) {
    grid-template-rows: 40px 50px 1fr;
    grid-template-columns: 1fr;
    height: auto;
  }
`;

const Layout = () => {
  return (
    <GridContainer>
      <Header />
      <Navbar />
      <Sidebar />
      <MainContent />
      <Chat />
    </GridContainer>
  );
};

export default Layout; 